import SellerNavbar from "../../components/sellers/SellerNavbar";
import SellerSignupForm from "../../components/sellers/SellerSignupForm";
import SellerFooter from "../../components/sellers/SellerFooter";

export default function SellerSignupPage() {
  return (
    <>
      <SellerNavbar />
      <SellerSignupForm />
      <SellerFooter />
    </>
  )
}

